import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { api } from "../../../../api";
import Cookies from "js-cookie";

const Deparment1 = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState("");
  const [project, setproject] = useState([]);
  const [department, setdepartment] = useState([]);
  const [filteredDepartments, setFilteredDepartments] = useState([]);
  const emp_id = Cookies.get("token");

  const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);

  // Helper to deduplicate departments by d_id
  const getUniqueDepartments = (departments) => {
    const map = new Map();
    departments.forEach((item) => {
      if (!map.has(item.d_id)) {
        map.set(item.d_id, item);
      }
    });
    return Array.from(map.values());
  };

  // Initial data fetch
  useEffect(() => {
    const fetchData = async () => {
      try {
        const company_id = Cookies.get('company_id');
        if (!company_id || !emp_id) {
          throw new Error('Missing company_id or emp_id in cookies');
        }
        
        // Fetch projects
        const projectResponse = await api.get(`viewProjectDetails.php?g_m_id=${emp_id}&company_id=${company_id}`);
        setproject(projectResponse.data);

        // Fetch all departments from the company
        const allDeptsResponse = await api.get(`department.php`);
        console.log("All departments from company:", allDeptsResponse.data);
        
        if (allDeptsResponse.data && Array.isArray(allDeptsResponse.data)) {
          // Filter departments for this company
          const companyDepartments = allDeptsResponse.data.filter(dept => dept.company_id === company_id);
          console.log("Filtered departments for company:", companyDepartments);
          
          // Get task completion data for each department by checking all projects
          const departmentsWithTasks = await Promise.all(
            companyDepartments.map(async (dept) => {
              try {
                // Get task completion data for this department across all projects
                let totalToDo = 0;
                let totalInProgress = 0;
                let totalTasks = 0;
                
                // Check each project for this department's tasks
                for (const proj of projectResponse.data) {
                  try {
                    const taskResponse = await api.get(`projectDepartments.php?id=${proj.p_id}&company_id=${company_id}`);
                    const deptData = taskResponse.data.find(d => d.d_id === dept.d_id);
                    if (deptData) {
                      totalToDo += parseInt(deptData.to_do_tasks) || 0;
                      totalInProgress += parseInt(deptData.in_progress_tasks) || 0;
                      totalTasks += parseInt(deptData.total_tasks) || 0;
                    }
                  } catch (error) {
                    console.log(`No task data for department ${dept.dept_name} in project ${proj.p_name}:`, error);
                  }
                }
                
                const taskCompletionPercentage = totalTasks > 0 ? 
                  Math.round((totalTasks - totalToDo - totalInProgress) / totalTasks * 100) : 0;
                
                return {
                  ...dept,
                  to_do_tasks: totalToDo,
                  in_progress_tasks: totalInProgress,
                  total_tasks: totalTasks,
                  task_completion_percentage: taskCompletionPercentage
                };
              } catch (error) {
                console.log(`Error processing department ${dept.dept_name}:`, error);
                return {
                  ...dept,
                  to_do_tasks: 0,
                  in_progress_tasks: 0,
                  total_tasks: 0,
                  task_completion_percentage: 0
                };
              }
            })
          );
          
          setdepartment(departmentsWithTasks);
          setFilteredDepartments(departmentsWithTasks);
        } else {
          console.log("No departments found for company");
          setdepartment([]);
          setFilteredDepartments([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [emp_id]);

  const handleProjectSelect = async (project) => {
    setSelectedProject(project.p_name);
    const company_id = Cookies.get('company_id');
    try {
      const response = await api.get(`projectDepartments.php?id=${project.p_id}&company_id=${company_id}`);
      console.log(`Department data for project ${project.p_name}:`, response.data);
      setFilteredDepartments(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      // If there's an error, show all departments
      setFilteredDepartments(department);
    }
  };

  return (
    <>
      <div className="header bg-gradient-info py-7 py-lg-8">
        <Container fluid>
          <Row className="mb-3">
            <Col className="order-xl-2  mb-xl-0 text-left ">
              <h1>Department Details</h1>
            </Col>
            <Col className="order-xl-2  mb-xl-0 d-flex justify-content-end">
              <div className="mb-4 ml-4">
                <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                  <DropdownToggle caret>
                    {selectedProject ? selectedProject : "Select Project"}
                  </DropdownToggle>
                  <DropdownMenu left>
                    <DropdownItem onClick={() => {
                      setSelectedProject("");
                      setFilteredDepartments(department);
                    }}>
                      Show All
                    </DropdownItem>
                    {Array.isArray(project) ? (
                      project.map((projectItem, index) => (
                        <DropdownItem
                          key={index}
                          onClick={() => handleProjectSelect(projectItem)}
                        >
                          {projectItem.p_name}
                        </DropdownItem>
                      ))
                    ) : (
                      <p>No projects available</p>
                    )}
                  </DropdownMenu>
                </Dropdown>
              </div>
            </Col>
          </Row>
        </Container>
        <Container fluid>
          <Row>
            {filteredDepartments && filteredDepartments.map((dept, index) => (
              <Col lg="6" xl="3" key={dept.d_id || index} className="mb-4">
                <Card
                  className="card-stats mb-4 mb-xl-0"
                  style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px' }}
                >
                  <CardBody
                    style={{
                      display: "grid",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div className="text-center">
                      <h3>{dept.dept_name}</h3>
                      <div
                        className="progress-bar-container m-4"
                        style={{ width: "100px", height: "100px" }}
                      >
                        <CircularProgressbar
                          value={dept.task_completion_percentage !== undefined && dept.task_completion_percentage !== null ? dept.task_completion_percentage : 0}
                          text={`${dept.task_completion_percentage !== undefined && dept.task_completion_percentage !== null ? dept.task_completion_percentage : 0}%`}
                          styles={buildStyles({
                            textColor: "blue",
                            pathColor: "#007bff",
                            trailColor: "#eee",
                            width: "60%",
                          })}
                        />
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Deparment1;